import { Box, styled } from '@mui/material';

export const FullSizeFlexContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  position: relative;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.palette.background.default};
`;
